<template>
  <div class="navbar-area position-relative">
    <div class="accordion d-flex justify-content-start align-items-center">
      <div class="accordion-item border-radius border-0 megamenu">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> dashboard </i>
          <span class="title lh-1"> Dashboard </span>
        </button>
      </div>
      <div class="accordion-item border-radius border-0">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> deployed_code </i>
          <span class="title lh-1"> Apps </span>
        </button>
        <div class="accordion-body border-radius">
          <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
            <li class="sidemenu-item">
              <RouterLink
                to="/apps/to-do-list"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> format_list_bulleted </i>
                <span class="title lh-1"> To Do List </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/apps/calendar"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> date_range </i>
                <span class="title lh-1"> Calendar </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/apps/contacts"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> contact_page </i>
                <span class="title lh-1"> Contacts </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/apps/chat"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> chat </i>
                <span class="title lh-1"> Chat </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> mail </i>
                <span class="title lh-1"> Email </span>
                <span
                  class="trezo-badge rounded-circle fw-medium d-inline-block text-center style-two"
                >
                  3
                </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/inbox"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Inbox
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/compose"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Compose
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/read-email"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Read
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/snoozed"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Snooozed
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/draft"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Draft
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/sent-mail"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Sent Mail
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/trash-email"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Trash
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/spam"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Spam
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/starred"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Starred
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/email/important"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Important
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/apps/kanban-board"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> team_dashboard </i>
                <span class="title lh-1"> Kanban Board </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> folder_open </i>
                <span class="title lh-1"> File Manager </span>
                <span
                  class="trezo-badge rounded-circle fw-medium d-inline-block text-center style-three"
                >
                  7
                </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/my-drive"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      My Drive
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/assets"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Assets
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/projects"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Projects
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/personal"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Personal
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/applications"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Applications
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/documents"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Documents
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/apps/file-manager/media"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Media
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="accordion-item border-radius border-0">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> layers </i>
          <span class="title lh-1"> Pages </span>
        </button>
        <div class="accordion-body border-radius">
          <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> note_stack </i>
                <span class="title lh-1"> Front Pages </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Home
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/features"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Features
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/our-team"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Our Team
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/faq"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      FAQ’s
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/contact"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Contact
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> shopping_cart </i>
                <span class="title lh-1"> eCommerce </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <button
                      type="button"
                      class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
                    >
                      Products
                    </button>
                    <div class="accordion-body border-radius">
                      <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                        <li class="sidemenu-item">
                          <RouterLink
                            to="/ecommerce/products-grid"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Products Grid
                          </RouterLink>
                        </li>
                        <li class="sidemenu-item">
                          <RouterLink
                            to="/ecommerce/products-list"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Products List
                          </RouterLink>
                        </li>
                        <li class="sidemenu-item">
                          <RouterLink
                            to="/ecommerce/product-details"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Product Details
                          </RouterLink>
                        </li>
                        <li class="sidemenu-item">
                          <RouterLink
                            to="/ecommerce/create-product"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Create Product
                          </RouterLink>
                        </li>
                        <li class="sidemenu-item">
                          <RouterLink
                            to="/ecommerce/edit-product"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Edit Product
                          </RouterLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/cart"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Cart
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/checkout"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Checkout
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/orders"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Orders
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/order-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Order Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/create-order"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create Order
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/order-tracking"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Order Tracking
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/customers"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Customers
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/customer-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Customer Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/categories"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Categories
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/sellers"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Sellers
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/seller-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Seller Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/create-seller"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create Seller
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/reviews"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Reviews
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ecommerce/refunds"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Refunds
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> handshake </i>
                <span class="title lh-1"> CRM </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crm/contacts"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Contacts
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crm/customers"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Customers
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crm/leads"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Leads
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crm/deals"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Deals
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> description </i>
                <span class="title lh-1"> Project Management </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/project-overview"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Project Overview
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/project-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Projects List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/create-project"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create Project
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/clients"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Clients
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/teams"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Teams
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/kanban-board"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Kanban Board
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/project-management/user"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Users
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> auto_stories </i>
                <span class="title lh-1"> LMS </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/courses-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Courses List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/course-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Course Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/lesson-preview"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Lesson Preview
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/create-course"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create Course
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/edit-course"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Edit Course
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/lms/instructors"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Instructors
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> support </i>
                <span class="title lh-1"> HelpDesk </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/help-desk/tickets"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Tickets
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/help-desk/ticket-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Ticket Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/help-desk/agents"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Agents
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/help-desk/reports"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Reports
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> store </i>
                <span class="title lh-1"> NFT Marketplace </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/marketplace"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Marketplace
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/explore-all"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Explore All
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/live-auction"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Live Auction
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/nft-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      NFT Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/creators"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Creators
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/creator-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Creator Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/nft-marketplace/wallet-connect"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Wallet Connect
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> real_estate_agent </i>
                <span class="title lh-1"> Real Estate </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/real-estate-customers"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Real Estate Customers
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/property-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Property List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/property-overview"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Property Overview
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/add-property"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Add Property
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/agent-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Agent list
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/agent-overview"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Agent Overview
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate/add-agent"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Add Agent
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> calculate </i>
                <span class="title lh-1"> Finance </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/finance/wallet"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Wallet
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/finance/transaction"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Transactions
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> badge </i>
                <span class="title lh-1"> Doctor </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/patients-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Patients List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/add-patient"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Add Patient
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/patient-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Patient Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/appointments"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Appointments
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/prescriptions"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Prescriptions
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/doctor/write-prescription"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Write a Prescription
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> lunch_dining </i>
                <span class="title lh-1"> Restaurant </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/restaurant/menus"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Menus
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/restaurant/dish-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Dish Details
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> hotel </i>
                <span class="title lh-1"> Hotel </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/hotel/rooms-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Rooms List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/hotel/room-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Room Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/hotel/guests-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Guests List
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> location_away </i>
                <span class="title lh-1"> Real Estate Agent </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate-agent/properties"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Properties
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/real-estate-agent/property-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Property Details
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> paid </i>
                <span class="title lh-1"> Crypto Trader </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crypto-trader/transactions"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Transactions
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crypto-trader/gainers-losers"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Gainers & Losers
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/crypto-trader/wallet-crypto"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Menus
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> local_activity </i>
                <span class="title lh-1"> Events </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/events"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Events Grid
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/events/events-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Events List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/events/event-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Event Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/events/create-an-event"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create An Event
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/events/edit-an-event"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Edit An Event
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> share </i>
                <span class="title lh-1"> Social </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/social/profile"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Profile
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/social/settings"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Settings
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> content_paste </i>
                <span class="title lh-1"> Invoices </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/invoices/invoice-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Invoices
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/invoices/invoice-details"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Invoice Details
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/invoices/create-invoice"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Create Invoice
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/invoices/edit-invoice"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Edit Invoice
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> person </i>
                <span class="title lh-1"> Users </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/users/team-members"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Team Members
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/users/users-list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Users List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/users/add-user"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Add User
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> account_box </i>
                <span class="title lh-1"> Profile </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/profile/user-profile"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      User Profile
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/profile/teams"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Teams
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/profile/my-projects"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Projects
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/starter"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> star_border </i>
                <span class="title lh-1"> Starter </span>
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
      <div class="accordion-item border-radius border-0">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> token </i>
          <span class="title lh-1"> Modules </span>
        </button>
        <div class="accordion-body border-radius">
          <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> qr_code_scanner </i>
                <span class="title lh-1"> UI Elements </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/alerts"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Alerts
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/avatar"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Avatars
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/buttons"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Buttons
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/badges"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Badges
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/cards"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Cards
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/carousels"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Carousels
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/dropdowns"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Dropdowns
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/grids"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Grids
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/images"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Images
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/list"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      List
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/modals"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Modals
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/navs"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Navs
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/paginations"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Paginations
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/popover-tooltips"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Popover Tooltips
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/progress"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Progress
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/spinners"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Spinners
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/tabs"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Tabs
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/accordions"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Accordions
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/date-time-picker"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Date Time Picker
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/ui-elements/videos"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Videos
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> emoji_emotions </i>
                <span class="title lh-1"> Icons </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/icons/material-icons"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Material Symbols
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/icons/remixicon"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      RemixIcon
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> table_chart </i>
                <span class="title lh-1"> Tables </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/tables/basic-table"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Basic Table
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/tables/data-tables"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Data Table
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> lock_open </i>
                <span class="title lh-1"> Authentication </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/login"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Login
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/register"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Register
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/reset-password"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Reset Password
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/forget-password"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Forgot Password
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/confirm-email"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Confirm Email
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/lock-screen"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Lock Screen
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/authentication/logout"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Logout
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> content_copy </i>
                <span class="title lh-1"> Extra Pages </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/pricing-plan"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Pricing
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/faq"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      FAQ’s
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/faq"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      FAQ
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/timeline"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Timeline
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/animation"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Animation
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/clip-board"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Clip Board
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/drag-drop"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Drag & Drop
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/range-slider"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Range Slider
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/ratings"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Ratings
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/toasts"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Toasts
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/check-radio"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Check & Radio
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/select"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Select
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/scrollbar"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Scrollbar
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/gallery"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Gallery
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/search"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Search
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/extra-pages/blank-page"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Blank Page
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> error </i>
                <span class="title lh-1"> Errors </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/error/not-found"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      404 Error Page
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/error/internal-error"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Internal Error
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/widgets"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> widgets </i>
                <span class="title lh-1"> Widgets </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/google-map"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> map </i>
                <span class="title lh-1"> Google Map </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/notification"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> notifications </i>
                <span class="title lh-1"> Notifications </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/members"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> people </i>
                <span class="title lh-1"> Members </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/apex-charts"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> pie_chart </i>
                <span class="title lh-1">Apex Charts</span>
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
      <div class="accordion-item border-radius border-0">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> forum </i>
          <span class="title lh-1"> Forms </span>
        </button>
        <div class="accordion-body border-radius">
          <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/basic-elements"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                Basic Elements
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/advanced-elements"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                Advanced Elements
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/validation"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                Validation
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/wizard"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                Wizards
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/editors"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                Editors
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/forms/file-upload"
                class="sidemenu-link border-radius d-block position-relative transition fw-medium"
              >
                File Upload
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
      <div class="accordion-item border-radius border-0">
        <button
          type="button"
          class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
        >
          <i class="material-symbols-outlined"> open_run </i>
          <span class="title lh-1"> Others </span>
        </button>
        <div class="accordion-body border-radius">
          <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
            <li class="sidemenu-item">
              <RouterLink
                to="/my-profile"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> account_circle </i>
                <span class="title lh-1"> My Profile </span>
              </RouterLink>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> settings </i>
                <span class="title lh-1"> Settings </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/settings/account-settings"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Account Settings
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/settings/change-password"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Change Password
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <RouterLink
                      to="/settings/connections"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Connections
                    </RouterLink>
                  </li>
                  <li class="sidemenu-item">
                    <a
                      href="https://smartrate.it/privacy-policy"
                      target="_blank"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li class="sidemenu-item">
                    <a
                      href="https://smartrate.it/termini-e-condizioni-generali-di-servizio"
                      target="_blank"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <button
                type="button"
                class="accordion-button with-icon text-start shadow-none fw-medium border-0 transition border-radius"
              >
                <i class="material-symbols-outlined"> unfold_more </i>
                <span class="title lh-1"> Multi Level Menu </span>
              </button>
              <div class="accordion-body border-radius">
                <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                  <li class="sidemenu-item">
                    <a
                      href="javascript:void(0)"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      First
                    </a>
                  </li>
                  <li class="sidemenu-item">
                    <a
                      href="javascript:void(0)"
                      class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                    >
                      Third
                    </a>
                  </li>
                  <li class="sidemenu-item">
                    <button
                      type="button"
                      class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
                    >
                      Third
                      <span
                        class="trezo-badge rounded-circle fw-medium d-inline-block text-center"
                      >
                        3
                      </span>
                    </button>
                    <div class="accordion-body border-radius">
                      <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                        <li class="sidemenu-item">
                          <a
                            href="javascript:void(0)"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Third 1
                          </a>
                        </li>
                        <li class="sidemenu-item">
                          <button
                            type="button"
                            class="accordion-button text-start shadow-none fw-medium border-0 transition border-radius"
                          >
                            Third 2
                          </button>
                          <div class="accordion-body border-radius">
                            <ul class="sidebar-sub-menu p-0 list-unstyled mb-0">
                              <li class="sidemenu-item">
                                <a
                                  href="javascript:void(0)"
                                  class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                                >
                                  Four 1
                                </a>
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li class="sidemenu-item">
                          <a
                            href="javascript:void(0)"
                            class="sidemenu-link border-radius d-block position-relative transition fw-medium"
                          >
                            Third 3
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li class="sidemenu-item">
              <RouterLink
                to="/authentication/logout"
                class="sidemenu-link with-icon border-radius d-block position-relative transition fw-medium"
              >
                <i class="material-symbols-outlined"> logout </i>
                <span class="title lh-1"> Logout </span>
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Navbar",
};
</script>

<style lang="scss" scoped>
.navbar-area {
  border-top: 1px solid var(--borderColor);
  max-width: 1295px;
  z-index: 999;
  margin: {
    top: 13px;
    left: auto;
    right: auto;
  }
  padding: {
    bottom: 0;
    top: 13px;
  }
  .accordion {
    gap: 6px;

    .accordion-item {
      background-color: transparent;
      color: var(--blackColor);
      white-space: nowrap;
      position: relative;

      .accordion-button {
        display: flex;
        align-items: center;
        color: var(--blackColor);
        font-size: var(--fontSize);
        background-color: transparent;
        padding: {
          bottom: 9px;
          right: 33px;
          left: 14px;
          top: 9px;
        }
        i {
          transition: var(--transition);
          color: var(--bodyColor);
          margin-right: 7px;
          font-size: 22px;
          line-height: 1;
        }
        .trezo-badge {
          padding: 0;
          width: 20px;
          height: 20px;
          font-size: 11px;
          line-height: 20px;
          color: var(--orangeColor);
          background-color: #fff5ed;
          margin: {
            left: 11px;
            right: 0;
          }
          &.style-two {
            color: #00b69b;
            background: rgba(0, 182, 155, 0.07);
          }
          &.style-three {
            color: #ee368c;
            background: rgba(238, 54, 140, 0.1);
          }
        }
        &::after {
          display: none;
        }
        &::before {
          top: 50%;
          right: 8px;
          margin-top: 1px;
          content: "\ea4e";
          position: absolute;
          color: var(--bodyColor);
          transform: translateY(-50%);
          transition: var(--transition);
          font: {
            size: 19px;
            family: remixicon;
          }
        }
        &:hover {
          color: var(--blackColor);
          background-color: #f6f7f9;

          i {
            color: var(--blackColor);
          }
          &::before {
            color: var(--blackColor);
          }
        }
      }
      &:has(.active) .accordion-button {
        color: var(--blackColor);
        background-color: #f6f7f9;

        i {
          color: var(--blackColor);
        }
        &::before {
          color: var(--blackColor);
        }
      }
      .accordion-body {
        left: 0;
        top: 100%;
        opacity: 0;
        z-index: 1;
        width: 270px;
        padding: 12px 0;
        margin-top: 13px;
        position: absolute;
        visibility: hidden;
        transition: var(--transition);
        background-color: var(--whiteColor);
        box-shadow: 0 0.25rem 1.125rem 0 rgba(47, 43, 61, 0.1);

        .accordion-button {
          color: var(--bodyColor);
          font-size: var(--fontSize);
          background-color: transparent;
          padding: {
            bottom: 10px;
            right: 10px;
            left: 31px;
            top: 10px;
          }
          &::after {
            top: 50%;
            left: 13px;
            width: 10px;
            content: "";
            height: 10px;
            transition: 0.3s;
            border-radius: 50%;
            position: absolute;
            display: inline-block;
            transform: translateY(-50%);
            background: unset !important;
            border: 1px solid var(--bodyColor);
          }
          i {
            margin-right: 0;
          }
          &:hover,
          &.active {
            background-color: #ecf0ff;
            color: var(--primaryColor);

            i {
              color: var(--primaryColor);
            }
            &::after {
              border-color: var(--primaryColor);
            }
            &::before {
              color: var(--primaryColor);
            }
          }
          .trezo-badge {
            top: 50%;
            padding: 0;
            right: 34px;
            width: 20px;
            height: 20px;
            font-size: 11px;
            line-height: 20px;
            position: absolute;
            color: var(--orangeColor);
            transform: translateY(-50%);
            background-color: #fff5ed;

            &.style-two {
              color: #00b69b;
              background: rgba(0, 182, 155, 0.07);
            }
            &.style-three {
              color: #ee368c;
              background: rgba(238, 54, 140, 0.1);
            }
          }
          &.with-icon {
            display: flex !important;
            align-items: center;
            padding-left: 12px;
            gap: 7px;

            i {
              font-size: 21px;
            }
            &::after {
              display: none;
            }
          }
        }
        .sidebar-sub-menu {
          .sidemenu-item {
            position: relative;
            padding: {
              left: 12px;
              right: 12px;
            }
            .sidemenu-link {
              color: var(--bodyColor);
              font-size: var(--fontSize);
              padding: {
                bottom: 10px;
                right: 12px;
                left: 31px;
                top: 10px;
              }
              &::after {
                top: 50%;
                left: 13px;
                width: 10px;
                content: "";
                height: 10px;
                transition: 0.3s;
                border-radius: 50%;
                position: absolute;
                transform: translateY(-50%);
                border: 1px solid var(--bodyColor);
              }
              &:hover,
              &.active {
                background-color: #ecf0ff;
                color: var(--primaryColor);

                &::after {
                  border-color: var(--primaryColor);
                }
              }
              .trezo-badge {
                top: -1px;
                padding: 2px 6px;
                margin-left: 5px;
                border-radius: 3px;
                line-height: initial;
                color: var(--orangeColor);
                background-color: #ffe8d4;
                font: {
                  size: 10px;
                  weight: normal;
                }
                &::before {
                  top: 50%;
                  left: -3px;
                  width: 6px;
                  height: 6px;
                  content: "";
                  position: absolute;
                  background: #ffe8d4;
                  transform: translateY(-50%) rotate(45deg);
                }
                &.style-two {
                  color: var(--successColor);
                  background-color: #d8ffc8;

                  &::before {
                    background: #d8ffc8;
                  }
                }
                &.style-three {
                  color: var(--purpleColor);
                  background-color: #eae0f3;

                  &::before {
                    background: #eae0f3;
                  }
                }
              }
              &.with-icon {
                display: flex !important;
                align-items: center;
                padding-left: 12px;
                gap: 7px;

                i {
                  font-size: 21px;
                }
                &::after {
                  display: none;
                }
              }
            }
            .accordion-body {
              top: 0;
              left: 100%;
              opacity: 0;
              margin-top: 0;
              visibility: hidden;

              .sidebar-sub-menu {
                .sidemenu-item {
                  .accordion-body {
                    opacity: 0;
                    // left: -100%;
                    visibility: hidden;

                    .sidebar-sub-menu {
                      .sidemenu-item {
                        .accordion-body {
                          opacity: 0;
                          // left: 100%;
                          visibility: hidden;
                        }
                        &:hover {
                          .accordion-body {
                            opacity: 1;
                            visibility: visible;
                          }
                        }
                      }
                    }
                  }
                  &:hover {
                    .accordion-body {
                      opacity: 1;
                      visibility: visible;
                    }
                  }
                }
              }
            }
            &:hover {
              .accordion-body {
                opacity: 1;
                visibility: visible;
              }
            }
          }
        }
      }
      &.megamenu {
        position: inherit;

        .accordion-body {
          width: auto;
          right: 0;
          padding: {
            left: 12px;
            right: 12px;
          }
          .sidebar-sub-menu {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin: {
              left: -5px;
              right: -5px;
            }
            .sidemenu-item {
              flex: 0 0 auto;
              width: 25%;
              padding: {
                left: 5px;
                right: 5px;
              }
            }
          }
        }
      }
      &:hover {
        .accordion-body {
          opacity: 1;
          visibility: visible;
        }
      }
      &:last-child {
        .accordion-body {
          left: auto;
          right: 0;

          .sidebar-sub-menu {
            .sidemenu-item {
              .accordion-body {
                left: -100%;

                .sidebar-sub-menu {
                  .sidemenu-item {
                    .accordion-body {
                      left: 100%;

                      .sidebar-sub-menu {
                        .sidemenu-item {
                          .accordion-body {
                            left: 100%;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .navbar-area {
    display: none;
  }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .navbar-area {
    display: none;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .navbar-area {
    max-width: 100%;

    .accordion {
      .accordion-item {
        .accordion-body {
          width: 250px;
        }
        &:last-child,
        &:nth-last-child(2) {
          .accordion-body {
            left: auto;
            right: 0;

            .sidebar-sub-menu {
              .sidemenu-item {
                .accordion-body {
                  left: -100%;

                  .sidebar-sub-menu {
                    .sidemenu-item {
                      .accordion-body {
                        left: -100%;

                        .sidebar-sub-menu {
                          .sidemenu-item {
                            .accordion-body {
                              left: 100%;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .navbar-area {
    max-width: 100%;

    .accordion {
      .accordion-item {
        .accordion-body {
          width: 250px;
        }
        &:last-child,
        &:nth-last-child(2) {
          .accordion-body {
            left: auto;
            right: 0;

            .sidebar-sub-menu {
              .sidemenu-item {
                .accordion-body {
                  left: -100%;

                  .sidebar-sub-menu {
                    .sidemenu-item {
                      .accordion-body {
                        left: -100%;

                        .sidebar-sub-menu {
                          .sidemenu-item {
                            .accordion-body {
                              left: 100%;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/* Min width 1600px */
@media only screen and (min-width: 1600px) {
  .navbar-area {
    max-width: 1545px;
  }
}
</style>
